module.exports = __webpack_public_path__ + "img/surfing.a8f4d84d.svg";